export default {"src":"/_next/static/media/file-icon.fad22403.svg","height":91,"width":69,"blurWidth":0,"blurHeight":0};